module.exports = __webpack_public_path__ + "static/media/dice-5.a6d32fc2.png";